import { Button, ButtonGroup } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { PipelineType } from '../../../types/optimizationProcesses'

type PipelineTypeToggleProps = {
  value: PipelineType
  onChange: (value: PipelineType) => void
}

export const PipelineTypeToggle = ({
  value,
  onChange,
}: PipelineTypeToggleProps) => {
  const { t } = useTranslation()

  return (
    <ButtonGroup label={t('Starting point')}>
      <Button
        label={t('pipelineTypeFromEmpty')}
        buttonType="button"
        type={value === 'from_empty' ? 'action' : 'default'}
        onClick={() => onChange('from_empty')}
      />
      <Button
        label={t('pipelineTypeFromLastConfig')}
        buttonType="button"
        type={value === 'from_last_config' ? 'action' : 'default'}
        onClick={() => onChange('from_last_config')}
      />
    </ButtonGroup>
  )
}
